import React from 'react';
import {productService} from '../../services/product.service';

class Xero extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			done: false,
			error: "Checking OAuth code...",
		}
	}

	componentDidMount() {
		productService.xeroCallback().then(response => {
			this.setState({done: response.done, error: response.error});
		});
	}

	render() {
		return <a href="/">
			{this.state.done ? "OAuth token has been saved. (Return to home page.)" :
			 this.state.error + " (Return to home page.)"}</a>;
	}
}

export default Xero;
